import script from "./jmqzManage.vue?vue&type=script&setup=true&lang=js"
export * from "./jmqzManage.vue?vue&type=script&setup=true&lang=js"

import "./jmqzManage.vue?vue&type=style&index=0&id=2991c848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2991c848"]])

export default __exports__